module.exports = {
	"LANGUAGE": "Idioma",
	"HDR-obpa_fulltext_score": "Resultado",
	"HDR-obpa_name": "Nombre",
	"HDR-obpa_fulltext_summary": "Resumen",
	"QUERY LIMIT REACHED": "Hay más resultados de los que se muestran. Limite sus criterios de búsqueda.",
	"NO DOCUMENTS FOUND": "No se han encontrado documentos.",
	"OPEN IN NEW WINDOW": "Abrir en una ventana nueva",
	"DOWNLOAD NATIVE": "Descargar en formato nativo",
	"CLOSE": "Cerrar",
	"SEARCH TYPE": "Tipo de búsqueda",
	"DOCUMENT TYPE": "Tipo de documento",
	"SEARCH TERM": "Término de búsqueda",
	"SEARCH": "Buscar",
	"RESET": "Restablecer",
	"DATE": "Fecha",
	"FROM DATE": "Fecha inicial",
	"TO DATE": "Fecha final",
	"LOADING": "Cargando...",
	"RETRY": "Reintentar",
	"ERROR": "¡Error!",
	"ERROR: QUERIES": "No se puede recuperar la lista de tipos de búsqueda.",
	"ERROR: DOCTYPES": "No se puede recuperar la lista de clases de documento.",
	"ERROR: KEYWORDS": "No se puede recuperar la lista de campos de búsqueda.",
	"ERROR: DOCUMENTS": "No se puede realizar la búsqueda solicitada.",
	"FORM: INVALID FULLTEXT": "El campo debe tener al menos {{chars}} caracteres.",
	"FORM: INVALID DATE SHORT": "Formato: {{format}} .",
	"FORM: REQUIRED KEYWORD": "El campo es obligatorio.",
	"FORM: INVALID NUMERIC": "El campo debe tener un número de hasta {{digits}} dígitos.",
	"FORM: INVALID DATE": "El campo debe seguir el formato {{format}} .",
	"FORM: INVALID CURRENCY": "El campo debe ser un valor de moneda válido.",
	"FORM: INVALID FLOAT": "El campo debe ser un número.",
	"FORM: INVALID LENGTH": "El campo debe tener un máximo de {{chars}} caracteres.",
	"FORM: ERRORS": "Hay errores en el formulario.",
	"FORM: noDate": "Debe especificarse un intervalo de fechas.",
	"FORM: noKeyword": "Debe especificarse al menos un campo.",
	"FORM: noDateOrKeyword": "Un intervalo de fechas O debe especificarse al menos un campo.",
	"FORM: noDateAndKeyword": "Un intervalo de fechas Y debe especificarse al menos un campo."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/es.json
// module id = 353
// module chunks = 0